import React from 'react';

const Experience = () => {
    return (
        <div className='experience'>
            <h3>A propos de moi</h3>
            <p>Fort d'une expérience réussie dans le domaine de la restauration, je donne un nouveau sens, une nouvelle orientation à ma carrière. J'ai découvert le développement Web il y a peu et j'ai décidé d'en faire mon nouveau métier.<br></br><br></br>

j'ai déjà effectué une formation de "Concepteur Développeur Front-End" et je suis actuellement une formation de "Développeur Web et Web Mobile" pour compléter ma première formation et acquérir les compétences Back-End.<br></br><br></br>

Dans le cadre de cette seconde formation il me faut effectuer un stage pratique en entreprise (non rémunéré) à partir du 28 Février 2022 au 20 Mai 2022.<br></br><br></br>

Je suis donc à la recherche d'une entreprise dynamique et innovante qui pourrait m'accueillir afin de compléter et parfaire mes compétences en cours d'acquisition.<br></br><br></br>

En retour je ferai preuve de dynamisme, motivation et engagement pour compléter votre équipe. Je saurai être un atout supplémentaire pour vous et vos collaborateurs.<br></br><br></br>

Je suis disponible pour vous donner plus de renseignements me concernant ou concernant le contenu de mes formations ainsi que les quelques projets que j'ai déjà réalisés.<br></br><br></br>

Contactez-moi ! Partageons ! +33 6 45 11 82 90

</p><br></br>
           
        </div>
    );
};

export default Experience;